module.exports = __webpack_public_path__ + "img/save-fill.79bdc199.svg";